module.exports = __webpack_public_path__ + "static/artist-development-the-process-2ca9afd05626a74392c8aecb4e3d1f70.png";